<div class="route-replay-container">
  <div class="route-replay-header">
    <h2>Route Replay</h2>
  </div>

  <div class="form-container">
    <!-- Date Picker -->
    <div class="form-field">
      <label>Select Date <span class="required-star">*</span></label>
      <input
        misTzDp
        class="date-input"
        [value]="displayFormat(selectedDate)"
        [selectedDate]="getCDSSelectedDate()"
        aria-label="Select Date"
        type="text"
        positionY="top"
        readonly
        [dpConfig]="datepickerConfig"
        placeholder="Select Date"
        positionX="start"
        (dateChange)="onDateSelected($event)"
      />
    </div>

    <!-- Shift Dropdown -->
    <div class="form-field">
      <label>Select Shift <span class="required-star">*</span></label>
      <mis-dropdown
        [width]="'100%'"
        [height]="'2.5rem'"
        [data]="shiftOptions"
        [selectedItem]="selectedShift"
        [label]="'Select Shift'"
        (onChange)="onShiftChange($event)"
      ></mis-dropdown>
    </div>

    <div class="form-field">
      <label>Filter by Direction</label>
      <mis-multi-select-dropdown
        [data]="directionOptions"
        label="Select Direction"
        width="100%"
        height="40px"
        [searchEnabled]="false"
        [selectedItems]="selectedDirections"
        [showSelectedCount]="true"
        [enableSelectAll]="true"
        [hideApplyButton]="false"
        (onChange)="onDirectionChange($event)"
        [options]="{ sortLabels: false }"
      ></mis-multi-select-dropdown>
      <span class="helper-text">
        Filter routes by Login/Logout direction
      </span>
    </div>

    <div class="form-field">
      <label>Select Routes <span class="required-star">*</span></label>
      <div [class.disabled-dropdown]="isRouteDropdownDisabled()">
        <mis-multi-select-dropdown
          [data]="routeOptions"
          label="Select Routes"
          width="100%"
          height="40px"
          [searchEnabled]="true"
          [selectedItems]="selectedRoutes"
          [showSelectedCount]="true"
          [enableSelectAll]="true"
          [hideApplyButton]="false"
          (onChange)="onRouteSelectionChange($event)"
          [options]="{ sortLabels: false }"
        ></mis-multi-select-dropdown>
      </div>
      <span *ngIf="isLoading" class="helper-text">
        Loading routes...
      </span>
      <span *ngIf="!routeOptions.length && !isLoading && selectedDate && selectedShift && selectedShift.value" class="helper-text">
        No routes available for selected date and shift
      </span>
      <span *ngIf="!selectedDate || !selectedShift || !selectedShift.value" class="helper-text">
        Please select date and shift to load routes
      </span>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button 
        class="btn-show" 
        [disabled]="!isFormValid()"
        (click)="onShow()"
      >
        Show
      </button>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner"></div>
  </div>
</div>
